/*
 * • FCSE Travelsearch Sandbox 2013 •
 *
 * © Copyright 2013, Tom Hulser [freshcells systems engineering GmbH]
 *
 *
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-events/eventDispatcher'],
    function($, _, EventDispatcher) {

        var Tabs = function(tabNavigationElement, tabContainerElement, options) {
            EventDispatcher.apply(this, arguments);

            this._options = $.extend({}, true, this._defaultOptions, options);

            if(tabNavigationElement instanceof jQuery) {
                this.tabNavigationElement = tabNavigationElement;
            } else {
                this.tabNavigationElement = $(tabNavigationElement);
            }

            if(tabContainerElement instanceof jQuery) {
                this.tabContainerElement = tabContainerElement;
            } else {
                this.tabContainerElement = $(tabContainerElement);
            }

            this._registerTabBarClickEvent();

            //Register events
            this.registerEvent('change');
        };

        Tabs.prototype = {
            _defaultOptions : {
                activeTabClassName : 'is-active',
                hideTabContentClassName : 'is-hidden'
            },
            _registerTabBarClickEvent : function () {
                var self = this;
                this.tabNavigationElement.on('click', 'a', function(e){
                    var $this = $(this);
                    var targetTabContainer = $this.attr('href');
                    self.switchTab(targetTabContainer);
                    e.preventDefault();
                });

                // the option tabNavigatorSelectorForOuterPointers is a navigator selector for outer handling of its tabs
                // for that you should also set to an outer element the attribute data-fcse-tab-pointer,
                // e.g. data-fcse-tab-pointer="#tabnavigation|#tab-overview", where tabnavigator selector is placed before "|" and then - tab id
                if (this.option('tabNavigatorSelectorForOuterPointers')) {
                    $('[data-fcse-tab-pointer^="' + this.option('tabNavigatorSelectorForOuterPointers') + '|"]').on('click', function(e) {
                        var targetTabContainer = $(this).attr('data-fcse-tab-pointer').split('|')[1];
                        if (targetTabContainer) {
                            self.switchTab(targetTabContainer);
                            $('html,body').animate({scrollTop: $(self.option('tabNavigatorSelectorForOuterPointers')).offset().top}, 'fast');
                            e.preventDefault();
                        }
                    });
                }
            },
            switchTab: function (targetTabContainer) {
                this.tabNavigationElement
                    .find('li')
                    .removeClass(this.option('activeTabClassName'));
                this.tabNavigationElement
                    .find('a[href="' + targetTabContainer + '"]')
                    .parent()
                    .addClass(this.option('activeTabClassName'));
                this.tabContainerElement
                    .addClass(this.option('hideTabContentClassName'));
                this.tabContainerElement
                    .filter(targetTabContainer)
                    .removeClass(this.option('hideTabContentClassName'));

                this.dispatchEvent("change", [this.tabNavigationElement
                    .find('a[href="' + targetTabContainer + '"]')
                    .parent().data('type')]);
            },
            /**
             * Gets or sets option
             * @param name
             * @param value optional
             */
            option: function (name, value) {
                if (!_.isUndefined(value)) {
                    this._options[name] = value;
                }
                return this._options[name];
            }
        };

        Tabs.prototype = $.extend(Object.create(Tabs.prototype), Object.create(EventDispatcher.prototype));

        return Tabs;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-content/tabs.js
// module id = 245
// module chunks = 5 6 22